import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { KTSVG } from '../../../_metronic/helpers'
import { CampaignFormModal } from './_modals/CampaignFormModal'
import { CampaignListModal } from './_modals/CampaignListModal'
import { DeleteModal } from '../../components/modals/DeleteModal'
import CampaignApi from '../../../infrastructure/api/CampaignApi'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../setup'
import { UserModel } from '../../modules/auth/models/UserModel'

const CampaignPage: FC = () => {
  const [itemId, setItemId] = useState(0)
  const [itemName, setItemName] = useState('')
  const [showDelete, setShowDelete] = useState(false)
  const handleCloseDelete = () => setShowDelete(false)
  const handleShowDelete = () => setShowDelete(true)

  const [refresh, setRefresh] = useState<number>(0)
  const [showForm, setShowForm] = useState(false)
  const handleCloseForm = () => { setShowForm(false); setRefresh(refresh + 1) }
  const handleShowForm = () => setShowForm(true)

  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

  const onClickItem = (value: number, name: string, type: string) => {
    setItemId(value)
    setItemName(name)
    switch (type) {
      case 'delete':
        handleShowDelete()
        break
      default:
        handleShowForm()
        break
    }
  }

  async function deleteCampaign(itemId: number) {
    var response = await CampaignApi.DeleteCampaign(itemId)
    setRefresh(refresh + 1)
  }

  return (
    <>
      <div className='card mb-5 mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'></h3>
          <div
            className='card-toolbar'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click to add a category'
          >
            <a
              href='#'
              onClick={() => onClickItem(0, '', 'create')}
              className='btn btn-sm btn-light-primary'
            >
              <KTSVG
                path='/media/icons/duotone/Code/Plus.svg'
                className='svg-icon-3'
              />
              Add Campaign
            </a>
          </div>
        </div>

        <div className='card-body py-3'>
          <CampaignListModal refresh={refresh} onClickItem={onClickItem} />
          <CampaignFormModal itemId={itemId} show={showForm} handleClose={handleCloseForm} />
          <DeleteModal
            itemId={itemId}
            itemName={itemName}
            handleClose={handleCloseDelete}
            show={showDelete}
            type='Blog Category'
            confirm={deleteCampaign}
          />
        </div>
      </div>
    </>
  )
}

const CampaignWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>Campaign</PageTitle>
      <CampaignPage />
    </>
  )
}

export { CampaignWrapper }
